import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/portfolio-cards.css";

const courseCategories = {
  journal: [
    {
      title: "Analisis Faktor-Faktor yang Mempengaruhi Minat Investasi Generasi Z",
      subject: "Jurnal",
      duration: "Published",
      capacity: "Vibe Research",
      icon: "ph-bold ph-chart-line-up",
      iconColor: "text-success-600",
      bgColor: "bg-success-25",
      borderColor: "border-success-200",
      description:
        "Penelitian tentang perilaku investasi generasi Z di Indonesia dengan fokus pada platform digital dan cryptocurrency serta faktor-faktor yang mempengaruhi keputusan investasi mereka.",
    },
    {
      title: "Implementasi Machine Learning dalam Prediksi Harga Saham",
      subject: "Jurnal",
      duration: "Published",
      capacity: "Vibe Research",
      icon: "ph-bold ph-robot",
      iconColor: "text-primary-600",
      bgColor: "bg-primary-25",
      borderColor: "border-primary-200",
      description:
        "Studi komparatif algoritma machine learning untuk prediksi pergerakan harga saham di Bursa Efek Indonesia menggunakan teknik deep learning dan analisis sentimen.",
    },
  ],
  thesis: [
    {
      title: "Pengaruh Work From Home terhadap Produktivitas dan Well-being Karyawan",
      subject: "Tesis",
      duration: "Completed",
      capacity: "Vibe Research",
      icon: "ph-bold ph-house",
      iconColor: "text-warning-600",
      bgColor: "bg-warning-25",
      borderColor: "border-warning-200",
      description:
        "Analisis mendalam dampak sistem kerja dari rumah terhadap produktivitas, kesejahteraan mental, dan work-life balance karyawan di era pasca pandemi.",
    },
    {
      title: "Strategi Digital Marketing untuk UMKM di Era Industri 4.0",
      subject: "Tesis",
      duration: "Completed",
      capacity: "Vibe Research",
      icon: "ph-bold ph-megaphone",
      iconColor: "text-info-600",
      bgColor: "bg-info-25",
      borderColor: "border-info-200",
      description:
        "Penelitian komprehensif tentang strategi pemasaran digital yang efektif untuk meningkatkan daya saing dan penetrasi pasar UMKM di Indonesia.",
    },
  ],
  dissertation: [
    {
      title: "Model Sustainable Tourism Development di Destinasi Wisata Indonesia",
      subject: "Disertasi",
      duration: "Completed",
      capacity: "Vibe Research",
      icon: "ph-bold ph-tree",
      iconColor: "text-success-600",
      bgColor: "bg-success-25",
      borderColor: "border-success-200",
      description:
        "Pengembangan model pariwisata berkelanjutan yang mengintegrasikan aspek ekonomi, sosial, dan lingkungan untuk destinasi wisata unggulan Indonesia.",
    },
    {
      title: "Transformasi Digital Sektor Pendidikan: Studi Multi-Kasus Universitas",
      subject: "Disertasi",
      duration: "Completed",
      capacity: "Vibe Research",
      icon: "ph-bold ph-graduation-cap",
      iconColor: "text-purple-600",
      bgColor: "bg-purple-25",
      borderColor: "border-purple-200",
      description:
        "Analisis komprehensif proses transformasi digital dalam sistem pendidikan tinggi di Indonesia dengan pendekatan multi-kasus dan framework teoritis yang robust.",
    },
  ],
};

const CourseCard = ({ course }) => {
  return (
    <div className={`course-item bg-white rounded-16 p-24 box-shadow-md transition-03 hover-border-main-600 border ${course.borderColor} item-hover position-relative overflow-hidden`}>
      {/* Icon Header with Gradient Background */}
      <div className="course-item__header text-center mb-20">
        <div className={`w-80 h-80 ${course.bgColor} rounded-circle mx-auto d-flex align-items-center justify-content-center mb-16 position-relative`}>
          <i className={`${course.icon} ${course.iconColor} text-4xl`} />
          {/* Decorative circles */}
          <div className="position-absolute top-0 end-0 w-20 h-20 bg-white rounded-circle opacity-20"></div>
          <div className="position-absolute bottom-0 start-0 w-12 h-12 bg-white rounded-circle opacity-30"></div>
        </div>
        <span className={`py-6 px-14 rounded-pill ${course.iconColor} fw-semibold ${course.bgColor} border ${course.borderColor} text-sm`}>
          {course.subject}
        </span>
      </div>

      {/* Content */}
      <div className="course-item__content">
        <h4 className="mb-16 text-center">
          <Link to="/program-details" className="link text-line-2 text-decoration-none text-neutral-800 hover-text-main-600">
            {course.title}
          </Link>
        </h4>
        
        <p className="text-neutral-600 text-sm mb-20 text-line-3 text-center px-2">
          {course.description}
        </p>

        {/* Meta Information */}
        <div className="d-flex justify-content-center gap-20 flex-wrap mb-20">
          <div className="flex-align gap-8">
            <span className={`text-lg d-flex ${course.iconColor}`}>
              <i className="ph-bold ph-clock" />
            </span>
            <span className="text-neutral-700 text-sm fw-medium">
              {course.duration}
            </span>
          </div>
          <div className="flex-align gap-8">
            <span className={`text-lg d-flex ${course.iconColor}`}>
              <i className="ph-bold ph-user-circle" />
            </span>
            <span className="text-neutral-700 text-sm fw-medium">
              {course.capacity}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className={`border-top ${course.borderColor} pt-20 text-center`}>
          <div className="mb-16">
            <span className="text-sm fw-semibold text-neutral-700 d-block">Tim Konsultan Penelitian</span>
            <span className="text-xs text-neutral-500">Publikasi & Konsultasi Akademik</span>
          </div>
          <Link 
            to="https://wa.me/6283131487736" 
            className={`btn btn-sm w-100 text-white fw-semibold rounded-pill py-8 px-20 ${course.iconColor.replace('text-', 'bg-')} hover-opacity-90 transition-03`}
          >
            <i className="ph-bold ph-whatsapp me-2"></i>
            Konsultasi Sekarang
          </Link>
        </div>
      </div>

      {/* Background Pattern */}
      <div className="position-absolute top-0 end-0 opacity-5">
        <i className={`${course.icon} text-8xl ${course.iconColor}`}></i>
      </div>
    </div>
  );
};

const TabContent = ({ courses }) => {
  return (
    <div className="row gy-4">
      {courses.map((course, index) => (
        <div
          key={index}
          className="col-lg-4 col-sm-6 wow fadeInUp"
          data-aos="fade-up"
          data-aos-duration={600 + index * 100}
        >
          <CourseCard course={course} />
        </div>
      ))}
    </div>
  );
};

const ExploreCourseThree = () => {
  const [activeTab, setActiveTab] = useState("all");

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <section className="explore-course py-120 bg-main-25 position-relative z-0">
      <div className="position-absolute start-0 top-0 w-100 z-index-n9">
        <img
          src="assets/images/shapes/cloud-shap-img2.png"
          alt=""
          className="w-100 z-n9"
        />
      </div>
      <div className="container ">
        <div className="max-w-611 text-center mx-auto mb-60">
          <div
            className="text-main-600 fw-semibold text-xl d-flex align-items-center gap-8 mb-16 justify-content-center flex-wrap"
            data-aos="fade-down"
          >
            <span>
              <i className="ph-bold ph-book" />
            </span>
            <span>Portfolio Penelitian</span>
          </div>
          <h2 className="mb-24 wow bounceIn">Hasil Karya Kami</h2>
          <p className="max-w-557-px text-md text-neutral-700 fw-normal wow bounceInUp">
            Vice Research telah membantu banyak peneliti dalam menyelesaikan karya ilmiah
            dan publikasi jurnal nasional maupun internasional
          </p>
        </div>
        <div className="text-center">
          <div
            className="nav-tab-wrapper bg-white p-16 mb-40 d-inline-block"
            data-aos="zoom-out"
          >
            <ul className="nav nav-pills common-tab gap-16">
              <li className="nav-item">
                <button
                  className={`nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 ${
                    activeTab === "all" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("all")}
                >
                  <i className="text-xl d-flex ph-bold ph-squares-four" />
                  Semua Program
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 ${
                    activeTab === "journal" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("journal")}
                >
                  <i className="text-xl d-flex ph-bold ph-book-open" />
                  Jurnal
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 ${
                    activeTab === "thesis" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("thesis")}
                >
                  <i className="text-xl d-flex ph-bold ph-file-text" />
                  Tesis
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 ${
                    activeTab === "dissertation" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("dissertation")}
                >
                  <i className="text-xl d-flex ph-bold ph-graduation-cap" />
                  Disertasi
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="tab-content">
          {activeTab === "all" && (
            <TabContent
              courses={[
                ...courseCategories.journal,
                ...courseCategories.thesis,
                ...courseCategories.dissertation,
              ]}
            />
          )}
          {activeTab === "journal" && <TabContent courses={courseCategories.journal} />}
          {activeTab === "thesis" && <TabContent courses={courseCategories.thesis} />}
          {activeTab === "dissertation" && (
            <TabContent courses={courseCategories.dissertation} />
          )}
        </div>
      </div>
      <div className="position-absolute start-0 bottom-0 w-100 z-index-n9">
        <img
          src="assets/images/shapes/cloud-shap-img1.png"
          alt=""
          className="w-100"
        />
      </div>
    </section>
  );
};

export default ExploreCourseThree;
